export default __webpack_public_path__ + "d518bb40626bb2ea7e958092eb6f3f32.svg";